import { APPLoginMask } from 'components/APPLoginMask'
import { useContext, useEffect } from 'react'
import { UserContext } from 'components/UserProvider'
import { useYdCourseApp } from 'hooks/useYdCourseApp'

export function YdCourseApp() {
  const { user } = useContext(UserContext)
  const { isYdCourseAppWebView } = useYdCourseApp(user)

  useEffect(() => {
    if(isYdCourseAppWebView) {
      window.ydk._invoke('setHorizontalScreen', {});
    }
  }, [isYdCourseAppWebView]);

  return (
    <>
      <APPLoginMask />
      {/* <CloseWebviewBtn /> */}
    </>
  );
}